<div *ngIf="isValidated$ | async"></div>
<div *ngIf="emailSource !== undefined" (focusout)="onBlur()" style="height: 90%">
<ngx-codemirror #codemirror
                class="templateAr3Source"
                [(ngModel)]="source"
                [options]="getCodeMirrorOptions()"
                (ngModelChange)="onChange()"
></ngx-codemirror>

  <input  type="checkbox" [(ngModel)]="lineWrapping" /> Line-wrap
  <input  type="checkbox" [(ngModel)]="autoCorrect" (ngModelChange)="onAutoCorrect()"/> Auto Correct
</div>